import React from 'react';
import { motion } from 'framer-motion';
import { Home, Building2, HardHat, Store, Truck, Sparkles, ArrowRight } from 'lucide-react';
const services = [{
  icon: Home,
  title: 'End of Tenancy Cleaning',
  description: 'Deep cleaning for landlords and tenants to ensure full deposit return. Includes appliances and carpets.'
}, {
  icon: Building2,
  title: 'Office Cleaning',
  description: 'Keep your workspace spotless and professional. Daily, weekly, or monthly schedules available.'
}, {
  icon: HardHat,
  title: 'Construction Cleaning',
  description: 'Specialized post-build cleanup to remove dust, debris, and residue from new renovations.'
}, {
  icon: Store,
  title: 'Commercial Cleaning',
  description: 'Tailored cleaning solutions for retail stores, showrooms, and commercial properties.'
}, {
  icon: Truck,
  title: 'Move-In / Move-Out',
  description: 'Stress-free cleaning transitions for your new home. Walk into a fresh, sanitized space.'
}, {
  icon: Sparkles,
  title: 'Deep Cleaning',
  description: 'Thorough top-to-bottom spring cleaning to refresh your home. We reach every corner.'
}];
export function Services() {
  return <section id="services" className="py-20 bg-white" data-id="element-203">
      <div className="container mx-auto px-4 md:px-6" data-id="element-204">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-206">
            Our Professional Cleaning Services
          </h2>
          <p className="text-lg text-gray-600" data-id="element-207">
            We offer a comprehensive range of cleaning solutions tailored to
            your specific needs in Glasgow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-208">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 rounded-2xl border border-gray-100 bg-white hover:border-teal-100 hover:shadow-xl hover:shadow-teal-900/5 transition-all duration-300" data-id="element-209">
              <div className="w-14 h-14 rounded-xl bg-teal-50 flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors duration-300" data-id="element-210">
                <service.icon className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors duration-300" data-id="element-211" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors" data-id="element-212">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-213">
                {service.description}
              </p>
              <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors" data-id="element-214">
                Get a Quote{' '}
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-215" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}